/**
 * Comprehensive Exam Subjects & Chapters Configuration
 * Maps each exam to subjects, specializations, and chapters based on official exam patterns
 */

export const EXAM_SUBJECTS = {
  // ==================== ENGINEERING EXAMS ====================
  
  "jee_main": {
    name: "JEE Main",
    subjects: [
      {
        name: "Physics",
        chapters: [
          // Mechanics
          "Units & Measurement",
          "Motion in 1D",
          "Motion in 2D",
          "Laws of Motion",
          "Work, Energy & Power",
          "Rotational Motion",
          "Gravitation",
          // Thermodynamics & Heat
          "Thermodynamics",
          "Heat Transfer",
          "Kinetic Theory",
          // Waves & Oscillations
          "Simple Harmonic Motion",
          "Waves",
          "Sound",
          "Doppler Effect",
          // Optics
          "Reflection & Refraction",
          "Lenses & Mirrors",
          "Wave Optics",
          "Interference & Diffraction",
          // Electromagnetism
          "Electric Field",
          "Gauss's Law",
          "Electric Potential",
          "Capacitors",
          "Current Electricity",
          "Ohm's Law",
          "Kirchhoff's Laws",
          "Magnetic Field",
          "Force on Current Carrying Conductor",
          "Magnetic Properties",
          "Electromagnetic Induction",
          "Faraday's Laws",
          "Alternating Current",
          // Modern Physics
          "Photoelectric Effect",
          "Atomic Structure",
          "Bohr's Model",
          "Nuclear Physics",
          "Semiconductors",
          "Communication Systems"
        ]
      },
      {
        name: "Chemistry",
        chapters: [
          // Physical Chemistry
          "Atomic Structure",
          "Bohr's Model",
          "Quantum Numbers",
          "Chemical Bonding",
          "Valence Bond Theory",
          "Molecular Orbital Theory",
          "States of Matter",
          "Solid State",
          "Gaseous State",
          "Liquid State",
          "Thermodynamics",
          "First Law",
          "Second Law",
          "Entropy",
          "Thermochemistry",
          "Chemical Equilibrium",
          "Equilibrium Constant",
          "Le Chatelier's Principle",
          "Ionic Equilibrium",
          "pH",
          "Buffer Solutions",
          "Hydrolysis",
          "Redox Reactions",
          "Oxidation Numbers",
          "Electrochemistry",
          "Galvanic Cells",
          "Electrolysis",
          "Nernst Equation",
          "Chemical Kinetics",
          "Solutions",
          "Surface Chemistry",
          // Inorganic Chemistry
          "Periodic Table",
          "Periodic Properties",
          "p-Block Elements",
          "Group 13-18",
          "d-Block Elements",
          "Transition Metals",
          "Coordination Compounds",
          "Metallurgy",
          "Qualitative Analysis",
          // Organic Chemistry
          "Hydrocarbons",
          "Alkanes",
          "Alkenes",
          "Alkynes",
          "Aromatic Compounds",
          "Alkyl Halides",
          "Alcohols",
          "Ethers",
          "Aldehydes",
          "Ketones",
          "Carboxylic Acids",
          "Amines",
          "Polymers",
          "Biomolecules",
          "Carbohydrates",
          "Proteins",
          "Lipids",
          "Nucleic Acids"
        ]
      },
      {
        name: "Mathematics",
        chapters: [
          // Algebra
          "Sets, Relations & Functions",
          "Complex Numbers",
          "Quadratic Equations",
          "Inequalities",
          "Sequences & Series",
          "Arithmetic Progression",
          "Geometric Progression",
          "Permutations & Combinations",
          "Binomial Theorem",
          // Trigonometry
          "Trigonometric Functions",
          "Trigonometric Equations",
          "Heights & Distances",
          "Inverse Trigonometry",
          // Coordinate Geometry
          "Straight Lines",
          "Circles",
          "Parabola",
          "Ellipse",
          "Hyperbola",
          "Conic Sections",
          // Calculus
          "Limits & Continuity",
          "Derivatives",
          "Rules of Differentiation",
          "Applications of Derivatives",
          "Integrals",
          "Indefinite Integrals",
          "Definite Integrals",
          "Applications of Integration",
          "Differential Equations",
          // Vectors & 3D Geometry
          "Vector Algebra",
          "3D Coordinate Geometry",
          "Direction Cosines",
          // Statistics & Probability
          "Probability",
          "Conditional Probability",
          "Distributions",
          "Mean & Variance",
          "Correlation & Regression"
        ]
      }
    ]
  },

  "jee_advanced": {
    name: "JEE Advanced",
    subjects: [
      {
        name: "Physics",
        chapters: [
          "Mechanics",
          "Rotational Motion",
          "Gravitation",
          "Fluids",
          "Thermodynamics & Heat",
          "Waves & Sound",
          "Optics",
          "Electrostatics",
          "Current & Magnetism",
          "Electromagnetic Induction",
          "Modern Physics",
          "Atomic Structure"
        ]
      },
      {
        name: "Chemistry",
        chapters: [
          "Mole Concept",
          "Atomic Structure",
          "Chemical Bonding",
          "Solid State",
          "Solutions & Colligative Properties",
          "Thermodynamics & Kinetics",
          "Equilibrium",
          "Redox Reactions & Electrochemistry",
          "Coordination Compounds",
          "Haloalkanes & Haloarenes",
          "Alcohol, Phenol & Ethers",
          "Aldehydes & Ketones",
          "Carboxylic Acids",
          "Amines & Organic Chemistry",
          "Qualitative Analysis"
        ]
      },
      {
        name: "Mathematics",
        chapters: [
          "Algebra",
          "Complex Numbers",
          "Quadratic Equations",
          "Sequences & Series",
          "Trigonometry",
          "Coordinate Geometry",
          "Vectors & 3D Geometry",
          "Calculus",
          "Limits, Continuity & Differentiability",
          "Applications of Derivatives",
          "Integrals & Areas",
          "Differential Equations",
          "Probability"
        ]
      }
    ]
  },

  "gate": {
    name: "GATE",
    subjects: [
      {
        name: "General Aptitude",
        chapters: [
          "Verbal Reasoning",
          "Verbal Ability",
          "Reading Comprehension",
          "Numerical Reasoning",
          "Numerical Computation",
          "Logical Reasoning",
          "Data Analysis"
        ]
      },
      {
        name: "Engineering Mathematics",
        chapters: [
          "Linear Algebra",
          "Matrices & Determinants",
          "Calculus",
          "Limits & Continuity",
          "Differentiation",
          "Integration",
          "Differential Equations",
          "Complex Variables",
          "Probability & Statistics",
          "Numerical Methods"
        ]
      },
      {
        name: "CSE Core Subjects",
        chapters: [
          "Digital Logic",
          "Computer Organization",
          "Programming & Data Structures",
          "Algorithms",
          "Theory of Computation",
          "Compiler Design",
          "Operating Systems",
          "Databases",
          "Computer Networks",
          "Web Technologies"
        ],
        specializations: ["Computer Science & IT (CS)"]
      },
      {
        name: "ECE Core Subjects",
        chapters: [
          "Circuit Analysis",
          "Signals & Systems",
          "Analog Circuits",
          "Digital Circuits",
          "Electromagnetics",
          "Microprocessors",
          "Control Systems",
          "Communications",
          "Antennas & Wave Propagation",
          "Microwave Engineering"
        ],
        specializations: ["Electronics & Communication (EC)"]
      },
      {
        name: "Mechanical Engineering",
        chapters: [
          "Engineering Mechanics",
          "Mechanics of Materials",
          "Theory of Machines",
          "Machine Design",
          "Fluid Mechanics",
          "Thermodynamics",
          "Heat Transfer",
          "Manufacturing Engineering",
          "Engineering Materials",
          "Operations Research"
        ],
        specializations: ["Mechanical Engineering (ME)"]
      }
    ],
    allSpecializations: [
      "Aerospace Engineering (AE)",
      "Agricultural Engineering (AG)",
      "Biomedical Engineering (BM)",
      "Civil Engineering (CE)",
      "Chemical Engineering (CH)",
      "Computer Science & IT (CS)",
      "Electrical Engineering (EE)",
      "Electronics & Communication (EC)",
      "Environmental Science & Engineering (ES)",
      "Geology & Geophysics (GG)",
      "Mechanical Engineering (ME)",
      "Mining Engineering (MN)",
      "Petroleum Engineering (PE)",
      "Textile Engineering (TF)",
      "Instrumentation Engineering (IN)",
      "Materials Science & Engineering (MS)",
      "Metallurgical Engineering (MT)",
      "Naval Architecture & Ocean Engineering (NA)",
      "Production & Industrial Engineering (PI)",
      "Engineering Sciences (XE)",
      "Life Sciences (XL)"
    ]
  },

  // ==================== MEDICAL EXAMS ====================

  "neet_ug": {
    name: "NEET UG",
    subjects: [
      {
        name: "Physics",
        chapters: [
          // Class 11
          "Physical World and Measurement",
          "Kinematics",
          "Laws of Motion",
          "Work, Energy and Power",
          "Motion of Systems of Particles and Rigid Body",
          "Gravitation",
          "Properties of Bulk Matter",
          "Thermodynamics",
          "Behaviour of Perfect Gas and Kinetic Theory",
          "Oscillations and Waves",
          // Class 12
          "Electrostatics",
          "Current Electricity",
          "Magnetic Effects of Current and Magnetism",
          "Electromagnetic Induction and Alternating Currents",
          "Electromagnetic Waves",
          "Optics",
          "Dual Nature of Matter and Radiation",
          "Atoms and Nuclei",
          "Electronic Devices"
        ]
      },
      {
        name: "Chemistry",
        chapters: [
          // Class 11
          "Some Basic Concepts of Chemistry",
          "Structure of Atom",
          "Classification of Elements and Periodicity in Properties",
          "Chemical Bonding and Molecular Structure",
          "States of Matter: Gases and Liquids",
          "Thermodynamics",
          "Equilibrium",
          "Redox Reactions",
          "Hydrogen",
          "s-Block Elements (Alkali and Alkaline Earth Metals)",
          "Some p-Block Elements",
          "Organic Chemistry - Some Basic Principles and Techniques",
          "Hydrocarbons",
          "Environmental Chemistry",
          // Class 12
          "Solid State",
          "Solutions",
          "Electrochemistry",
          "Chemical Kinetics",
          "Surface Chemistry",
          "General Principles and Processes of Isolation of Elements",
          "p-Block Elements",
          "d and f Block Elements",
          "Coordination Compounds",
          "Haloalkanes and Haloarenes",
          "Alcohols, Phenols and Ethers",
          "Aldehydes, Ketones and Carboxylic Acids",
          "Organic Compounds Containing Nitrogen",
          "Biomolecules",
          "Polymers",
          "Chemistry in Everyday Life"
        ]
      },
      {
        name: "Biology",
        chapters: [
          // Class 11
          "The Living World",
          "Biological Classification",
          "Plant Kingdom",
          "Animal Kingdom",
          "Morphology of Flowering Plants",
          "Anatomy of Flowering Plants",
          "Structural Organisation in Animals",
          "Cell: The Unit of Life",
          "Biomolecules",
          "Cell Cycle and Cell Division",
          "Transport in Plants",
          "Photosynthesis in Higher Plants",
          "Respiration in Plants",
          "Plant Growth and Development",
          "Digestion and Absorption",
          "Breathing and Exchange of Gases",
          "Body Fluids and Circulation",
          "Excretory Products and their Elimination",
          "Locomotion and Movement",
          "Neural Control and Coordination",
          "Chemical Coordination and Integration",
          "Diversity in the Living World",
          // Class 12
          "Reproduction",
          "Sexual Reproduction in Flowering Plants",
          "Human Reproduction",
          "Reproductive Health",
          "Principles of Inheritance and Variation",
          "Molecular Basis of Inheritance",
          "Evolution",
          "Human Health and Disease",
          "Strategies for Enhancement in Food Production",
          "Microbes in Human Welfare",
          "Biotechnology: Principles and Processes",
          "Biotechnology and its Applications",
          "Organisms and Populations",
          "Ecosystem",
          "Biodiversity and Conservation",
          "Environmental Issues"
        ]
      }
    ]
  },

  "aiims": {
    name: "AIIMS",
    subjects: [
      {
        name: "Physics",
        chapters: ["Mechanics", "Thermodynamics", "Waves & Optics", "Electromagnetism", "Modern Physics"]
      },
      {
        name: "Chemistry",
        chapters: ["Inorganic", "Physical Chemistry", "Organic Chemistry"]
      },
      {
        name: "Biology",
        chapters: ["Botany", "Zoology", "Genetics", "Ecology"]
      },
      {
        name: "General Knowledge",
        chapters: ["Current Affairs", "History", "Geography", "Science & Technology"]
      },
      {
        name: "Aptitude",
        chapters: ["Logical Reasoning", "Analytical Reasoning", "Data Interpretation"]
      }
    ]
  },

  "jipmer": {
    name: "JIPMER",
    subjects: [
      {
        name: "Physics",
        chapters: ["Mechanics", "Heat & Thermodynamics", "Waves & Sound", "Optics", "Electricity & Magnetism", "Modern Physics"]
      },
      {
        name: "Chemistry",
        chapters: ["General Chemistry", "Inorganic Chemistry", "Physical Chemistry", "Organic Chemistry"]
      },
      {
        name: "Biology",
        chapters: ["Botany", "Zoology", "Human Physiology", "Genetics"]
      },
      {
        name: "English",
        chapters: ["Reading Comprehension", "Grammar", "Vocabulary"]
      },
      {
        name: "Logic & Reasoning",
        chapters: ["Logical Reasoning", "Analytical Reasoning", "Pattern Recognition"]
      }
    ]
  },

  // ==================== UNIVERSITY ENTRANCE ====================

  "cuet_ug": {
    name: "CUET UG",
    subjects: [
      {
        name: "Language",
        chapters: ["English", "Regional Languages", "Comprehension", "Grammar", "Vocabulary"]
      },
      {
        name: "Domain Subject",
        chapters: ["Science", "Commerce", "Arts", "Mathematics", "Biology", "Economics"]
      },
      {
        name: "General Test",
        chapters: ["Quantitative Reasoning", "General Awareness", "Logical Reasoning", "Reading Comprehension"]
      }
    ]
  },

  // ==================== MANAGEMENT EXAMS ====================

  "cat": {
    name: "CAT",
    subjects: [
      {
        name: "VARC",
        chapters: [
          "Reading Comprehension",
          "Sentence Correction",
          "Sentence Elimination",
          "Parajumbles",
          "Paragraph Jumbles",
          "Paragraph Completion",
          "Critical Reasoning",
          "Vocabulary"
        ]
      },
      {
        name: "DILR",
        chapters: [
          "Data Interpretation",
          "Bar Charts",
          "Pie Charts",
          "Line Graphs",
          "Tables",
          "Caselet",
          "Logical Reasoning",
          "Syllogisms",
          "Puzzles",
          "Arrangements",
          "Blood Relations",
          "Directions",
          "Analytical Reasoning",
          "Games & Tournaments"
        ]
      },
      {
        name: "Quantitative Ability",
        chapters: [
          "Number Systems",
          "Percentages",
          "Profit & Loss",
          "Simple Interest & Compound Interest",
          "Time & Work",
          "Speed, Distance & Time",
          "Averages & Ratios",
          "Mixtures & Alligations",
          "Probability",
          "Permutation & Combination",
          "Sequences & Series",
          "Algebra",
          "Geometry & Trigonometry",
          "Coordinate Geometry",
          "Set Theory",
          "Functions & Graphs",
          "Quadratic Equations",
          "Logarithms",
          "Surds & Indices"
        ]
      }
    ]
  },

  // ==================== GOVERNMENT EXAMS ====================

  "upsc_cse": {
    name: "UPSC CSE",
    subjects: [
      {
        name: "General Studies",
        chapters: [
          "Indian History",
          "Ancient India",
          "Medieval India",
          "Modern India",
          "Independence Movement",
          "Indian Geography",
          "Physical Geography",
          "Human Geography",
          "Climate & Weather",
          "Natural Resources",
          "Indian Polity",
          "Constitution",
          "Government Structure",
          "Rights & Duties",
          "Political Parties",
          "Indian Economy",
          "Economic Policies",
          "Development Issues",
          "Environmental Issues",
          "Biodiversity",
          "Conservation",
          "Climate Change",
          "Current Affairs",
          "Science & Technology",
          "Medical Science",
          "Space Technology",
          "IT & Digitalization"
        ]
      },
      {
        name: "CSAT",
        chapters: [
          "Comprehension",
          "Interpersonal Skills",
          "Decision Making",
          "Problem Solving",
          "Analytical Ability",
          "Logical Reasoning",
          "Quantitative Reasoning",
          "Data Interpretation"
        ]
      }
    ]
  },

  "ssc_cgl": {
    name: "SSC CGL",
    subjects: [
      {
        name: "Reasoning",
        chapters: [
          "Analogies",
          "Classification",
          "Series Completion",
          "Coding-Decoding",
          "Blood Relations",
          "Directions & Distances",
          "Logical Venn Diagrams",
          "Syllogism",
          "Puzzle Tests",
          "Clock & Calendar",
          "Matrix",
          "Arrangements"
        ]
      },
      {
        name: "General Awareness",
        chapters: [
          "History of India",
          "Geography of India",
          "Indian Politics",
          "Economics",
          "General Science",
          "Physics",
          "Chemistry",
          "Biology",
          "Current Affairs",
          "Sports",
          "Important Events",
          "Awards & Honors",
          "Books & Authors"
        ]
      },
      {
        name: "Quantitative Aptitude",
        chapters: [
          "Number Systems",
          "Percentages",
          "Profit & Loss",
          "Simple Interest",
          "Compound Interest",
          "Ratio & Proportion",
          "Time & Work",
          "Speed, Distance & Time",
          "Averages",
          "Mixtures & Alligations",
          "Geometry",
          "Trigonometry",
          "Algebra",
          "Data Interpretation",
          "Probability",
          "Permutation & Combination"
        ]
      },
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Synonyms & Antonyms",
          "Sentence Correction",
          "Spotting Errors",
          "Fill in the Blanks",
          "Sentence Improvement",
          "Sentence Rearrangement",
          "Grammar",
          "Vocabulary",
          "Idioms & Phrases"
        ]
      }
    ]
  },

  "ssc_chsl": {
    name: "SSC CHSL",
    subjects: [
      {
        name: "Reasoning",
        chapters: [
          "Analogies",
          "Classification",
          "Series",
          "Coding-Decoding",
          "Problem Solving",
          "Direction Sense",
          "Blood Relations",
          "Logical Deduction",
          "Venn Diagrams"
        ]
      },
      {
        name: "General Awareness",
        chapters: [
          "India & World",
          "History",
          "Geography",
          "Polity",
          "Economics",
          "General Science",
          "Books & Authors",
          "Sports",
          "Important Days"
        ]
      },
      {
        name: "Quantitative Aptitude",
        chapters: [
          "Simplification",
          "Percentage",
          "Profit & Loss",
          "Time & Work",
          "Speed & Distance",
          "Simple Interest",
          "Compound Interest",
          "Ratio & Proportion",
          "Geometry",
          "Trigonometry",
          "Data Interpretation"
        ]
      },
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Cloze Test",
          "Sentence Correction",
          "Vocabulary",
          "Grammar",
          "Synonyms & Antonyms",
          "Sentence Rearrangement",
          "Spotting Errors"
        ]
      }
    ]
  },

  "rrb_ntpc": {
    name: "RRB NTPC",
    subjects: [
      {
        name: "General Awareness",
        chapters: [
          "Current Affairs",
          "History",
          "Geography",
          "Polity",
          "Economics",
          "General Science",
          "Railway",
          "Sports",
          "Culture"
        ]
      },
      {
        name: "Mathematics",
        chapters: [
          "Number Systems",
          "Percentages",
          "Profit & Loss",
          "Simple Interest",
          "Time & Work",
          "Speed & Distance",
          "Geometry",
          "Trigonometry",
          "Algebra",
          "Data Interpretation"
        ]
      },
      {
        name: "Reasoning",
        chapters: [
          "Analogies",
          "Classification",
          "Series",
          "Coding-Decoding",
          "Direction Sense",
          "Problem Solving",
          "Logical Deduction",
          "Pattern Recognition"
        ]
      }
    ]
  },

  // ==================== BANKING EXAMS ====================

  "ibps_po": {
    name: "IBPS PO",
    subjects: [
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Cloze Test",
          "Sentence Correction",
          "Vocabulary",
          "Grammar",
          "Parajumbles",
          "Spotting Errors",
          "Sentence Improvement"
        ]
      },
      {
        name: "Quantitative Aptitude",
        chapters: [
          "Simplification",
          "Number Systems",
          "Percentage",
          "Profit & Loss",
          "Simple Interest",
          "Compound Interest",
          "Time & Work",
          "Speed & Distance",
          "Ratio & Proportion",
          "Averages",
          "Geometry",
          "Data Interpretation"
        ]
      },
      {
        name: "Reasoning",
        chapters: [
          "Syllogism",
          "Circular Arrangements",
          "Linear Arrangements",
          "Coding-Decoding",
          "Blood Relations",
          "Direction Sense",
          "Inequality",
          "Puzzle",
          "Logical Reasoning",
          "Data Sufficiency"
        ]
      }
    ]
  },

  "ibps_clerk": {
    name: "IBPS Clerk",
    subjects: [
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Cloze Test",
          "Sentence Correction",
          "Grammar",
          "Vocabulary",
          "Spotting Errors",
          "Parajumbles"
        ]
      },
      {
        name: "Numerical Ability",
        chapters: [
          "Simplification",
          "Number Systems",
          "Percentage",
          "Profit & Loss",
          "Simple Interest",
          "Compound Interest",
          "Time & Work",
          "Speed & Distance",
          "Averages",
          "Ratio & Proportion",
          "Data Interpretation"
        ]
      },
      {
        name: "Reasoning",
        chapters: [
          "Analogies",
          "Classification",
          "Series",
          "Coding-Decoding",
          "Direction Sense",
          "Blood Relations",
          "Arrangements",
          "Puzzle",
          "Logical Reasoning"
        ]
      }
    ]
  },

  "sbi_po": {
    name: "SBI PO",
    subjects: [
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Cloze Test",
          "Sentence Correction",
          "Grammar",
          "Vocabulary",
          "Parajumbles",
          "Error Spotting"
        ]
      },
      {
        name: "Quantitative Aptitude",
        chapters: [
          "Simplification",
          "Number Systems",
          "Percentage",
          "Profit & Loss",
          "Interest",
          "Time & Work",
          "Speed & Distance",
          "Ratio & Proportion",
          "Geometry",
          "Data Interpretation",
          "Series"
        ]
      },
      {
        name: "Reasoning",
        chapters: [
          "Logical Reasoning",
          "Coding-Decoding",
          "Direction Sense",
          "Blood Relations",
          "Arrangements",
          "Puzzles",
          "Syllogism",
          "Inequality",
          "Data Sufficiency"
        ]
      }
    ]
  },

  "sbi_clerk": {
    name: "SBI Clerk",
    subjects: [
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Grammar",
          "Vocabulary",
          "Cloze Test",
          "Error Detection"
        ]
      },
      {
        name: "Numerical Ability",
        chapters: [
          "Simplification",
          "Percentage",
          "Profit & Loss",
          "Interest",
          "Time & Work",
          "Speed & Distance",
          "Averages",
          "Ratio & Proportion",
          "Data Interpretation"
        ]
      },
      {
        name: "Reasoning",
        chapters: [
          "Logical Reasoning",
          "Coding-Decoding",
          "Direction Sense",
          "Blood Relations",
          "Arrangements",
          "Series"
        ]
      }
    ]
  },

  // ==================== LAW EXAMS ====================

  "clat": {
    name: "CLAT",
    subjects: [
      {
        name: "English",
        chapters: [
          "Reading Comprehension",
          "Vocabulary",
          "Grammar",
          "Spellings",
          "Usage"
        ]
      },
      {
        name: "General Knowledge",
        chapters: [
          "History",
          "Polity",
          "Geography",
          "Science",
          "Current Affairs"
        ]
      },
      {
        name: "Legal Reasoning",
        chapters: [
          "Legal Principles",
          "Case Analysis",
          "Legal Analogies",
          "Scenario-based",
          "Statutory Interpretation"
        ]
      },
      {
        name: "Logical Reasoning",
        chapters: [
          "Analogies",
          "Classification",
          "Series",
          "Coding",
          "Puzzles",
          "Data Arrangement"
        ]
      },
      {
        name: "Quantitative Aptitude",
        chapters: [
          "Number Systems",
          "Percentage",
          "Profit & Loss",
          "Simple Interest",
          "Time & Work",
          "Speed & Distance",
          "Geometry"
        ]
      }
    ]
  },

  // ==================== DEFENCE EXAMS ====================

  "nda": {
    name: "NDA",
    subjects: [
      {
        name: "Mathematics",
        chapters: [
          "Sets",
          "Relations",
          "Functions",
          "Complex Numbers",
          "Quadratic Equations",
          "Sequences & Series",
          "Permutations & Combinations",
          "Trigonometry",
          "Algebra",
          "Matrices & Determinants",
          "Calculus",
          "Differential Equations",
          "Probability"
        ]
      },
      {
        name: "General Ability",
        chapters: [
          "Physics",
          "Chemistry",
          "Biology",
          "Social Studies",
          "Geography",
          "Current Events"
        ]
      },
      {
        name: "General Knowledge",
        chapters: [
          "History",
          "Civics",
          "Geography",
          "General Science",
          "Current Affairs"
        ]
      }
    ]
  },

  "cds": {
    name: "CDS",
    subjects: [
      {
        name: "English",
        chapters: [
          "Comprehension",
          "Grammar",
          "Vocabulary",
          "Sentence Rearrangement",
          "Error Detection"
        ]
      },
      {
        name: "General Knowledge",
        chapters: [
          "History",
          "Geography",
          "Civics",
          "Science",
          "Current Affairs"
        ]
      },
      {
        name: "Elementary Mathematics",
        chapters: [
          "Arithmetic",
          "Algebra",
          "Geometry",
          "Trigonometry",
          "Mensuration",
          "Statistics"
        ]
      }
    ]
  },

  // ==================== INTEGRATED MSc EXAMS ====================

  "nest": {
    name: "NEST",
    subjects: [
      {
        name: "Physics",
        chapters: [
          "Mechanics",
          "Heat & Thermodynamics",
          "Waves & Oscillations",
          "Electromagnetism",
          "Optics",
          "Modern Physics",
          "Atomic Structure",
          "Nuclear Physics"
        ]
      },
      {
        name: "Chemistry",
        chapters: [
          "Atomic Structure",
          "Chemical Bonding",
          "Thermodynamics",
          "Equilibrium",
          "Kinetics",
          "Redox Reactions",
          "Organic Chemistry",
          "Inorganic Chemistry"
        ]
      },
      {
        name: "Mathematics",
        chapters: [
          "Sets & Relations",
          "Complex Numbers",
          "Quadratic Equations",
          "Sequences & Series",
          "Trigonometry",
          "Coordinate Geometry",
          "Calculus",
          "Linear Algebra"
        ]
      },
      {
        name: "Biology",
        chapters: [
          "Cell Biology",
          "Genetics",
          "Evolution",
          "Ecology",
          "Plant Physiology",
          "Animal Physiology",
          "Biochemistry",
          "Molecular Biology"
        ]
      }
    ]
  },

  // ==================== SCIENCE RESEARCH EXAMS ====================

  "iat": {
    name: "IISER Aptitude Test",
    subjects: [
      {
        name: "Physics",
        chapters: [
          // Mechanics
          "Units and Measurement",
          "Kinematics",
          "Laws of Motion",
          "Work, Energy and Power",
          "Rotational Motion",
          "Gravitation",
          // Properties of Matter
          "Mechanical Properties of Solids",
          "Mechanical Properties of Fluids",
          "Thermal Properties of Matter",
          // Thermodynamics
          "Thermodynamics",
          "Kinetic Theory of Gases",
          // Oscillations & Waves
          "Oscillations",
          "Waves",
          // Electromagnetism
          "Electric Charges and Fields",
          "Electrostatic Potential and Capacitance",
          "Current Electricity",
          "Moving Charges and Magnetism",
          "Magnetism and Matter",
          "Electromagnetic Induction",
          "Alternating Current",
          "Electromagnetic Waves",
          // Optics
          "Ray Optics",
          "Wave Optics",
          // Modern Physics
          "Dual Nature of Radiation and Matter",
          "Atoms",
          "Nuclei",
          "Semiconductor Electronics"
        ]
      },
      {
        name: "Chemistry",
        chapters: [
          // Physical Chemistry
          "Some Basic Concepts of Chemistry",
          "Structure of Atom",
          "Classification of Elements",
          "Chemical Bonding",
          "States of Matter",
          "Thermodynamics",
          "Equilibrium",
          "Redox Reactions",
          "Electrochemistry",
          "Chemical Kinetics",
          "Surface Chemistry",
          // Inorganic Chemistry
          "Hydrogen",
          "s-Block Elements",
          "p-Block Elements",
          "d and f Block Elements",
          "Coordination Compounds",
          // Organic Chemistry
          "Basic Principles of Organic Chemistry",
          "Hydrocarbons",
          "Haloalkanes and Haloarenes",
          "Alcohols, Phenols and Ethers",
          "Aldehydes, Ketones and Carboxylic Acids",
          "Amines",
          "Biomolecules"
        ]
      },
      {
        name: "Biology",
        chapters: [
          // Diversity of Living Organisms
          "The Living World",
          "Biological Classification",
          "Plant Kingdom",
          "Animal Kingdom",
          // Structural Organisation
          "Morphology of Flowering Plants",
          "Anatomy of Flowering Plants",
          "Structural Organisation in Animals",
          // Cell Structure and Function
          "Cell: The Unit of Life",
          "Biomolecules",
          "Cell Cycle and Cell Division",
          // Plant Physiology
          "Transport in Plants",
          "Photosynthesis",
          "Respiration in Plants",
          "Plant Growth and Development",
          // Human Physiology
          "Digestion and Absorption",
          "Breathing and Exchange of Gases",
          "Body Fluids and Circulation",
          "Excretory Products",
          "Locomotion and Movement",
          "Neural Control and Coordination",
          // Genetics & Evolution
          "Principles of Inheritance",
          "Molecular Basis of Inheritance",
          "Evolution",
          // Biology and Human Welfare
          "Human Health and Disease",
          "Biotechnology Principles",
          "Biotechnology Applications",
          // Ecology
          "Organisms and Populations",
          "Ecosystem",
          "Biodiversity and Conservation"
        ]
      },
      {
        name: "Mathematics",
        chapters: [
          // Sets and Functions
          "Sets",
          "Relations and Functions",
          "Trigonometric Functions",
          // Algebra
          "Complex Numbers",
          "Quadratic Equations",
          "Linear Inequalities",
          "Permutations and Combinations",
          "Binomial Theorem",
          "Sequences and Series",
          // Coordinate Geometry
          "Straight Lines",
          "Conic Sections",
          "3D Geometry",
          // Calculus
          "Limits and Derivatives",
          "Continuity and Differentiability",
          "Applications of Derivatives",
          "Integrals",
          "Applications of Integrals",
          "Differential Equations",
          // Vectors & 3D
          "Vectors",
          "Three Dimensional Geometry",
          // Linear Programming
          "Linear Programming",
          // Probability
          "Probability",
          "Statistics"
        ]
      }
    ]
  }
};

// Map common exam names to keys
const NAME_TO_KEY_MAP = {
  // JEE
  'jee main': 'jee_main',
  'jee_main': 'jee_main',
  'joint entrance examination': 'jee_main',
  'joint entrance examination (main)': 'jee_main',
  'jee advanced': 'jee_advanced',
  'jee_advanced': 'jee_advanced',
  'joint entrance examination (advanced)': 'jee_advanced',
  
  // NEET
  'neet ug': 'neet_ug',
  'neet_ug': 'neet_ug',
  'neet': 'neet_ug',
  'national eligibility cum entrance test': 'neet_ug',
  'neet pg': 'neet_pg',
  'neet_pg': 'neet_pg',
  
  // Management
  'cat': 'cat',
  'common admission test': 'cat',
  'xat': 'xat',
  'xavier aptitude test': 'xat',
  
  // Government
  'upsc cse': 'upsc_cse',
  'upsc_cse': 'upsc_cse',
  'upsc': 'upsc_cse',
  'civil services examination': 'upsc_cse',
  'ssc cgl': 'ssc_cgl',
  'ssc_cgl': 'ssc_cgl',
  'ssc chsl': 'ssc_chsl',
  'ssc_chsl': 'ssc_chsl',
  'rrb ntpc': 'rrb_ntpc',
  'rrb_ntpc': 'rrb_ntpc',
  
  // Engineering
  'gate': 'gate',
  'graduate aptitude test in engineering': 'gate',
  'bitsat': 'bitsat',
  'bits admission test': 'bitsat',
  
  // Science
  'iat': 'iat',
  'iiser aptitude test': 'iat',
  'nest': 'nest',
  'national entrance screening test': 'nest',
  'iisc bs': 'iisc_bs',
  'iisc_bs': 'iisc_bs',
  
  // Banking
  'ibps po': 'ibps_po',
  'ibps_po': 'ibps_po',
  'ibps clerk': 'ibps_clerk',
  'ibps_clerk': 'ibps_clerk',
  'sbi po': 'sbi_po',
  'sbi_po': 'sbi_po',
  'sbi clerk': 'sbi_clerk',
  'sbi_clerk': 'sbi_clerk',
  'rbi grade b': 'rbi_grade_b',
  'rbi_grade_b': 'rbi_grade_b',
  
  // Defence
  'nda': 'nda',
  'national defence academy': 'nda',
  'cds': 'cds',
  'combined defence services': 'cds',
  'afcat': 'afcat',
  'air force common admission test': 'afcat',
  
  // Law
  'clat': 'clat',
  'common law admission test': 'clat',
  'ailet': 'ailet',
  'all india law entrance test': 'ailet',
  
  // Design
  'nid dat': 'nid_dat',
  'nid_dat': 'nid_dat',
  'nata': 'nata',
  'national aptitude test in architecture': 'nata',
  'uceed': 'uceed',
  
  // CUET
  'cuet': 'cuet_ug',
  'cuet ug': 'cuet_ug',
  'cuet_ug': 'cuet_ug',
  'common university entrance test': 'cuet_ug',
  
  // Legacy mappings
  'aiims': 'aiims',
  'jipmer': 'jipmer',
};

/**
 * Normalize exam ID or name to key
 */
const normalizeExamKey = (examIdOrName) => {
  if (!examIdOrName) return null;
  const normalized = examIdOrName.toLowerCase().trim();
  return NAME_TO_KEY_MAP[normalized] || normalized.replace(/[\s-]/g, '_');
};

/**
 * Get exam data by ID or name
 */
const getExamData = (examIdOrName) => {
  const key = normalizeExamKey(examIdOrName);
  return EXAM_SUBJECTS[key] || null;
};

/**
 * Get exam name from exam ID or name
 */
export const getExamName = (examIdOrName) => {
  const exam = getExamData(examIdOrName);
  return exam?.name || examIdOrName;
};

/**
 * Get subjects for an exam (by ID or name)
 */
export const getExamSubjects = (examIdOrName) => {
  const exam = getExamData(examIdOrName);
  if (!exam || !exam.subjects) return [];
  return exam.subjects.map(s => s.name);
};

/**
 * Get chapters for a specific subject (by exam ID or name)
 */
export const getSubjectChapters = (examIdOrName, subjectName) => {
  const exam = getExamData(examIdOrName);
  if (!exam || !exam.subjects) return [];
  const subject = exam.subjects.find(s => s.name.toLowerCase() === subjectName.toLowerCase());
  return subject?.chapters || [];
};

/**
 * Get all specializations for an exam (like GATE papers)
 */
export const getExamSpecializations = (examIdOrName) => {
  const exam = getExamData(examIdOrName);
  return exam?.allSpecializations || [];
};

/**
 * Check if exam has multiple subjects
 */
export const hasMultipleSubjects = (examIdOrName) => {
  const subjects = getExamSubjects(examIdOrName);
  return subjects.length > 1;
};

/**
 * Check if exam has chapters
 */
export const hasChapters = (examIdOrName, subjectName) => {
  const chapters = getSubjectChapters(examIdOrName, subjectName);
  return chapters.length > 0;
};

